import { Navigate, useParams } from 'react-router-dom';
import { useMemo } from 'react';
import Loader from './Loader';
import { useGetQrReservation } from 'api/qr';
import { withCustomerAuth } from 'components/withCustomerAuth';

function ReviewRedirect() {
  const { id } = useParams();
  const { reservationData, reservationLoading, reservationError } = useGetQrReservation(id || null);

  const targetPath = useMemo(() => {
    if (!id || !reservationData) {
      return null;
    }

    if (reservationData.type === 'general') {
      const params = new URLSearchParams({
        qr_id: id,
        restaurant_id: String(reservationData.restaurant_id)
      });

      if (reservationData.restaurant_name) {
        params.set('restaurant_name', reservationData.restaurant_name);
      }

      return `/feedback/general?${params.toString()}`;
    }

    const reservationId = reservationData.reservation_id ?? 'no-reservation';
    const waiterId = reservationData.waiter_id ?? 'no-waiter';
    const restaurantId = reservationData.restaurant_id;

    return `/feedback/${waiterId}?reservation_id=${reservationId}&restaurant_id=${restaurantId}&qr_id=${id}`;
  }, [reservationData, id]);

  if (reservationLoading) {
    return <Loader />;
  }

  if (reservationError || !reservationData || !id || !targetPath) {
    return <Navigate to="/" replace />;
  }

  return <Navigate to={targetPath} replace />;
}

export default withCustomerAuth(ReviewRedirect);
